// native
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

// service
import { ItemsDisplayService } from '../../../core/services/items-display.service';
import { CitationsQueueService } from '../../../core/services/citations-queue.service';
import { GlobalsService } from '../../../core/services/globals.service';
import { UtilityService } from '../../../core/services/utility.service';

// models
import { IDisplayItem, IItemCitationOptions } from '../../../models';

@Component({
  selector: 'scs-options-panel',
  templateUrl: './options-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionsPanelComponent implements OnInit {

  form: UntypedFormGroup;
  item: IDisplayItem;
  itemKey: string;

  positionOptions = [
    { id: 'Book', name: 'Book' },
    { id: 'Chapter', name: 'Chapter' },
    { id: 'Column', name: 'Column' },
    { id: 'Figure', name: 'Figure' },
    { id: 'Folio', name: 'Folio' },
    { id: 'Issue', name: 'Issue' },
    { id: 'Line', name: 'Line' },
    { id: 'Note', name: 'Note' },
    { id: 'Opus', name: 'Opus' },
    { id: 'Page', name: 'Page' },
    { id: 'Paragraph', name: 'Paragraph' },
    { id: 'Part', name: 'Part' },
    { id: 'Section', name: 'Section' },
    { id: 'Sub Verbo', name: 'Sub Verbo' },
    { id: 'Verse', name: 'Verse' },
    { id: 'Volume', name: 'Volume' }
  ];

  constructor(
    public itemsDisplayService: ItemsDisplayService,
    private formBuilder: UntypedFormBuilder,
    private citationsQueueService: CitationsQueueService,
    private globalsService: GlobalsService,
    private utilityService: UtilityService
  ) { }

  ngOnInit(): void {
    this.item = this.itemsDisplayService.getPanelOptionsItem();
    this.itemKey = this.item.collection_id + ':' + this.item.id;

    this.initForm();
  }

  onClose() {
    this.itemsDisplayService.optionsPanelVisible$.next(false);
  }

  onCancel() {
    this.itemsDisplayService.optionsPanelVisible$.next(false);
  }

  initForm() {
    const items = this.citationsQueueService.citationQueueOptions?.items;
    const itemOptions = items ? items[this.itemKey] : null;

    let positionName: string = itemOptions?.position?.name
    let positionValue: string = itemOptions?.position?.value
    let prefix: string = itemOptions?.prefix;
    let suffix: string = itemOptions?.suffix;
    let suppressAuthor = itemOptions?.suppressAuthor;

    this.form = this.formBuilder.group({
      positionName: [positionName],
      positionValue: [positionValue],
      prefix: [prefix],
      suffix: [suffix],
      suppressAuthor: [suppressAuthor]
    });

    if (!positionName)
      this.form.controls['positionName'].setValue('Chapter');
  }

  onSave() {
    this.form.markAllAsTouched();

    const options: IItemCitationOptions = {
      position: {
        name: this.form.controls.positionName.value,
        value: this.form.controls.positionValue.value,
      },
      prefix: this.form.controls.prefix.value,
      suffix: this.form.controls.suffix.value,
      suppressAuthor: this.form.controls.suppressAuthor.value,
    };

    // if position key value pair is incomplete, no position data will be sent
    if (!this.form.controls.positionName.value || !this.form.controls.positionValue.value)
      options.position = null;

    if (!this.citationsQueueService.citationQueueOptions)
      this.citationsQueueService.citationQueueOptions = { items: {} };

    else if (!this.citationsQueueService.citationQueueOptions.items)
      this.citationsQueueService.citationQueueOptions.items = {};

    this.citationsQueueService.citationQueueOptions.items[this.itemKey] = options;

    this.itemsDisplayService.optionsPanelVisible$.next(false);
  }

  onEditArticleClick() {
    const editUrl = `${this.globalsService.appConfig.environment.baseUrls.app}/library/${this.item.collection_id}/all/(sidepanel:edit)?item_id=${this.item.id}&collection_id=${this.item.collection_id}`;
    window.open(editUrl, '_blank');
  }

  getYear(item: IDisplayItem) {
    return this.utilityService.getYearFromMetadata(item.custom_metadata?.date) || 'Unknown year';
  }
}
